import React from "react";

const ShopeeWorkspaceContext = React.createContext(null);

export default ShopeeWorkspaceContext;
